import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { DynamicConfigField } from "../../form/formTypes"
import { DynamicDateTime } from "../../form/DynamicDateTime"

const useStyles = makeStyles()((theme) => ({
    fieldLabel: {
        color: theme.palette.tailwind.slate[600],
    },
}))

type DeferredMeetingTimeFieldsProps = Readonly<{
    meetingTimeFields: {
        startTime?: DynamicConfigField
        endTime?: DynamicConfigField
    }
}>

export function DeferredMeetingTimeFields({ meetingTimeFields }: DeferredMeetingTimeFieldsProps) {
    const { classes } = useStyles()
    const { startTime, endTime } = meetingTimeFields

    return (
        <>
            {startTime && (
                <Stack gap=".5rem">
                    <LocalizedStrict id="create-order-extra-services-additional-fields-start-time-label">
                        <Typography variant="body2" className={classes.fieldLabel}>
                            When does the meeting start?
                        </Typography>
                    </LocalizedStrict>
                    <DynamicDateTime config={ensureInputField(startTime)} skipPreFill />
                </Stack>
            )}
            {endTime && (
                <Stack gap=".5rem">
                    <LocalizedStrict id="create-order-extra-services-additional-fields-end-time-label">
                        <Typography variant="body2" className={classes.fieldLabel}>
                            When does the meeting end?
                        </Typography>
                    </LocalizedStrict>
                    <DynamicDateTime config={ensureInputField(endTime)} skipPreFill />
                </Stack>
            )}
        </>
    )
}

function ensureInputField(config: DynamicConfigField): DynamicConfigField {
    const activeConfig = config.active ? config : { ...config, active: true as const }
    return activeConfig.inputField ? activeConfig : { ...activeConfig, inputField: { type: "dateTime" as const } }
}
